module.exports = __webpack_public_path__ + "static/img/raw-quartz_256.96b029a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/raw-quartz_256.png
// module id = SDEq
// module chunks = 0